import { mdiHandBackLeftOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { Box, Tooltip } from '@mui/material'
import { FC } from 'react'
import { useTranslate } from 'react-admin'

export interface ManualScaleBadgeProps {
  /** The source has reported this scale too (merged by scale id). */
  seenInSource: boolean
}

/**
 * The hand marks a scale created by hand rather than by the berthing source.
 * Neutral until the source reports the same scale id, green once merged with it.
 */
export const ManualScaleBadge: FC<ManualScaleBadgeProps> = ({ seenInSource }) => {
  const translate = useTranslate()
  const label = translate(seenInSource ? 'components.manual_scale.label_seen_in_source' : 'components.manual_scale.label')
  return (
    <Tooltip title={label}>
      <Box
        role="img"
        aria-label={label}
        data-testid={seenInSource ? 'manual-scale-badge-seen-in-source' : 'manual-scale-badge'}
        sx={{
          display: 'inline-flex',
          p: 0.5,
          borderRadius: '50%',
          border: 1,
          borderColor: seenInSource ? 'success.light' : 'grey.300',
          bgcolor: seenInSource ? 'success.50' : 'grey.50',
          color: seenInSource ? 'success.dark' : 'grey.700',
        }}
      >
        <Icon path={mdiHandBackLeftOutline} size="18px" />
      </Box>
    </Tooltip>
  )
}
